var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 50,
    height: 30,
    fill: "#FDBC64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 10,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseservice);
export default __webpack_public_path__ + "static/media/houseservice.f23e00cd31d63f988aa26f108a0e7e9d.svg";
export { ForwardRef as ReactComponent };